// Valeurs écrites dans support_tickets par le widget, alignées sur les
// contraintes CHECK de la table. Une valeur hors liste fait échouer l'insert en
// 23514 et l'utilisateur perd son ticket : chaque sortie de ces fonctions doit
// donc rester dans la liste admise, quelle que soit la réponse de l'IA.

// support_tickets_severity_check
export const TICKET_SEVERITIES = [
  "low",
  "normal",
  "high",
  "critical",
  "blocker",
] as const;

// Sous-ensemble de support_tickets_type_check (élargie par la migration
// 20260929160000) que le widget peut écrire.
export const WIDGET_TICKET_TYPES = [
  "bug",
  "question",
  "feature",
  "feedback",
  "other",
] as const;

// support_tickets_type_check, complète et dans l'ordre de la contrainte :
// vocabulaire d'origine (e-mail entrant, anciens tickets) puis celui de la
// classification IA, puis « abuse » (signalement d'un sondage depuis la page
// de vote, #1370). Sert au filtre admin, qui doit pouvoir montrer tout ce
// que la base contient.
export const TICKET_TYPES = [
  "creation",
  "participation",
  "export",
  "integration",
  "account",
  "bug",
  "billing",
  "question",
  "feature",
  "feedback",
  "other",
  "abuse",
] as const;

export type TicketSeverity = (typeof TICKET_SEVERITIES)[number];
export type WidgetTicketType = (typeof WIDGET_TICKET_TYPES)[number];
export type TicketType = (typeof TICKET_TYPES)[number];

/** Sévérité IA → valeur admise ; absente ou inconnue → « normal ». */
export function toTicketSeverity(
  raw: string | null | undefined,
): TicketSeverity {
  const value = raw?.toLowerCase();
  return (TICKET_SEVERITIES as readonly string[]).includes(value ?? "")
    ? (value as TicketSeverity)
    : "normal";
}

/**
 * Classification IA → type admis. Absente (analyse IA échouée) → « question » ;
 * inconnue (ex. « complex ») → « other ».
 */
export function toTicketType(
  classification: string | null | undefined,
): WidgetTicketType {
  const value = classification?.toLowerCase();
  if (!value) return "question";
  return (WIDGET_TICKET_TYPES as readonly string[]).includes(value)
    ? (value as WidgetTicketType)
    : "other";
}
